import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const BROWN       = [109, 78, 54];
const BROWN_LIGHT = [245, 237, 228];
const WHITE       = [255, 255, 255];
const GRAY_LINE   = [200, 185, 170];

const safe = (v) => (v === null || v === undefined || v === '' ? '—' : String(v));

const formatDate = (value) => {
  if (!value) return null;
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString('fr-FR');
  } catch {
    return String(value);
  }
};

// ── Bon de remise de matériel informatique ────────────────────────
export const generateBonRemisePDF = ({
  appareil,
  affecte_a,
  societe,
  date_affectation,
  date_retour_prevu,
  note,
  userName,
} = {}) => {
  const now = new Date();
  const currentDate = now.toLocaleDateString('fr-FR');
  const currentTime = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.width;

  // ── Bandeau titre ─────────────────────────────────────────────
  doc.setFillColor(...BROWN);
  doc.rect(0, 0, pageW, 28, 'F');

  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...WHITE);
  doc.text('BON DE REMISE DE MATÉRIEL INFORMATIQUE', pageW / 2, 12, { align: 'center' });

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Généré le ${currentDate} à ${currentTime}`, pageW / 2, 21, { align: 'center' });

  // ── Bloc bénéficiaire ─────────────────────────────────────────
  doc.setFillColor(...BROWN_LIGHT);
  doc.roundedRect(14, 34, pageW - 28, 26, 3, 3, 'F');
  doc.setDrawColor(...GRAY_LINE);
  doc.roundedRect(14, 34, pageW - 28, 26, 3, 3, 'S');

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BROWN);
  doc.text('Bénéficiaire :', 20, 43);
  doc.text('Société :', 20, 51);
  doc.text('Date de remise :', 110, 43);
  doc.text('Retour prévu :', 110, 51);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(30, 30, 30);
  doc.text(safe(affecte_a), 49, 43);
  doc.text(safe(societe || appareil?.societe), 43, 51);
  doc.text(formatDate(date_affectation) || currentDate, 143, 43);
  doc.text(formatDate(date_retour_prevu) || '—', 143, 51);

  // ── Détail appareil ───────────────────────────────────────────
  autoTable(doc, {
    startY: 66,
    head: [['Type', 'Marque', 'Modèle', 'N° série', 'IMEI', 'État']],
    body: [[
      safe(appareil?.type_appareil),
      safe(appareil?.marque),
      safe(appareil?.modele),
      safe(appareil?.numero_serie),
      safe(appareil?.imei),
      safe(appareil?.etat),
    ]],
    styles: { fontSize: 9, cellPadding: 3, halign: 'center' },
    headStyles: { fillColor: BROWN, textColor: 255, fontStyle: 'bold' },
    margin: { left: 14, right: 14 },
  });

  let y = doc.lastAutoTable.finalY + 10;

  // ── Accessoires / observations ────────────────────────────────
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BROWN);
  doc.setFontSize(10);
  doc.text('Accessoires / Observations :', 14, y);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(30, 30, 30);
  const noteLines = doc.splitTextToSize(note ? String(note) : 'Aucune', pageW - 28);
  doc.text(noteLines, 14, y + 6);
  y += 6 + noteLines.length * 5;

  // ── Zones de signature ────────────────────────────────────────
  y += 20;
  const pageH = doc.internal.pageSize.height;
  if (y + 30 > pageH) y = pageH - 30;

  doc.setDrawColor(...GRAY_LINE);
  doc.line(pageW / 2 - 35, y, pageW / 2 + 35, y);

  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  doc.text('Signature du bénéficiaire', pageW / 2, y + 6, { align: 'center' });
  if (userName) doc.text(`Remis par : ${safe(userName)}`, 20, y - 6);

  const fileName = `Bon_Remise_${safe(appareil?.marque).replace(/[^\w-]+/g, '_')}_${safe(affecte_a).replace(/\s+/g, '_')}.pdf`;
  doc.save(fileName);
};

export default generateBonRemisePDF;
